import { useSelector } from 'react-redux';

export default function useGetLotteryAndPrizeAndPromoData() {
    const { isMgmSelf, isMgmShare } = useSelector(s => s.flags);
    const isHasReferral = Boolean(isMgmSelf) || Boolean(isMgmShare);
    // ----- 原模組 -----
    const { uuid: promoUuid, id: promoId } = useSelector(s => s.promo);
    const userGameResultRecords = useSelector(s => s.userGameResultRecords);
    const lotteryParticipant = useSelector(s => s.lotteryParticipant);
    const { uuid: lotteryParticipantUuid } = lotteryParticipant;
    const lotteryPrizes = useSelector(s => s.lotteryPrizes || {});
    const lotteryParticipantPrize = lotteryPrizes[lotteryParticipantUuid] || [];

    // ----- Referral -----
    const { mgmReferral: { uuid: mgmPromoUuid, id: mgmPromoId } = {} } = useSelector(
        s => s.mgmRelation
    );
    const {
        lotteryParticipant: mgmLotteryParticipant = {},
        lotteryTasks: mgmLotteryTasks = {},
        lotteryPrizes: mgmLotteryPrizes = {}
    } = useSelector(s => s.mgmReferral);
    const { uuid: mgmLotteryParticipantUuid } = mgmLotteryParticipant;
    const mgmLotteryParticipantPrize = mgmLotteryPrizes[mgmLotteryParticipantUuid] || [];
    const mgmLotteryTaskUuids = Object.keys(mgmLotteryTasks);
    const mgmLotteryTaskPrizes = (() => {
        return [].concat.apply(
            [],
            mgmLotteryTaskUuids.map(uuid => mgmLotteryPrizes[uuid])
        );
    })();

    // 啟用共用獎
    const isEnableSharePrize = lotteryParticipantPrize.some(({ uuid }) =>
        mgmLotteryParticipantPrize.some(({ uuid: mgmUuid }) => uuid === mgmUuid)
    );

    const checkIsNormalPromoEntryByGameResult = (entryUuid = '') => {
        // 透過 GameResult 來判斷該 Entry 是來自一般模組還是 Referral
        return Boolean(userGameResultRecords.find(({ uuid } = {}) => uuid === entryUuid));
    };

    const checkIsReferralPrize = (prizeUuid, entryUuid) => {
        return isEnableSharePrize
            ? checkIsNormalPromoEntryByGameResult(entryUuid)
                ? false
                : true
            : mgmLotteryParticipantPrize.some((item = {}) => item.uuid === prizeUuid) ||
                  mgmLotteryTaskPrizes.some(({ uuid } = {}) => uuid === prizeUuid);
    };

    const getPromoByPrizeAndEntry = (prizeUuid, entryUuid) => {
        return isHasReferral && checkIsReferralPrize(prizeUuid, entryUuid)
            ? { uuid: mgmPromoUuid, id: mgmPromoId }
            : { uuid: promoUuid, id: promoId };
    };

    return {
        isEnableSharePrize,
        getPromoByPrizeAndEntry
    };
}
